import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { postData } from "../../../../../api/componentAPIs";
import MESSAGES from "../../../../../appMessages";
import Events from "../../../../../utilities/EventEmitter";
import { convertDateTimeToTimeString, formatMonthDateYear, formatTime, isTimeValid } from '@dataGrid/gridUtilities';
import StyledDateTimeEditor from "../DriverPopUp/common/StyledDateTimeEditor";
import appConstants from "../../../../../appConstants";
import { format, isValid } from "date-fns";
import { getTerminalDateWithOffset, formatArriveAtTerminalTime } from "../../utils/utils";
const BACKSPACE_KEYCODE = 8;

const styles = (theme) => ({
  root: {
    padding: "8px 12px",
    verticalAlign: "middle",
    height: "100%",
    color: theme.gridIconBorderColor,
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
  },
  label: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
  },
  checked: {
    color: theme.HeaderSelectedText,
  },
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    width: 314,
    userSelect: "none",
  },
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.palette.primary.main,
    padding: 0,
  },
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  confirmButton: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",

    margin: 0,
    width: "47%",
    color: theme.ModalBGColor,
    "&$disabledConfirmButton": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  button: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",

    margin: 0,
    width: "47%",
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$actionButton": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  actionButton: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  closeButton: { color: theme.iconColor, padding: "0px 10px" },
  dialogTitlestyle: {
    padding: 0,
    height: "20px",
  },
  circularProgress: {
    color: theme.white,
  },
  disabledConfirmButton: {
    backgroundColor: theme.palette.primary.main,
  },
  dateTimeEditor: {
    "& .dateTimeContainer": {
      maxWidth: "100%",
      width: "100%",
      height: 28,
      border: `1px solid ${theme.tooltipBorderColor}`,
    },
  },
  datesContainer: {
    padding: "16px 0",
  },
  dateTimeTitle: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    fontWeight: 400,
    lineHeight: "16px",
  },
  datesInnerContainer: {
    margin: "10px 0",
  },
  dateTimeValue: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 500,
    lineHeight: "16px",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center",
    marginTop: 6,
  },
  dateInfo: {
    display: "flex",
    flexDirection: "column",
  },
  errorMsgs: {
    color: theme.ErrorMessageColor,
    marginLeft:'auto',
    width:"50%"
  },
});

class EndTripConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEndTripInProgress: false,
      endDate: null,
      endTime: null,
      formError: false,
      isInvalidEndDate: false,
      isInvalidEndTime: false,
      errorInfo: {
        endDate: null,
        endTime: null,
      },
    };
  }

  componentDidMount() {
    Events.on("EndOfTripCompleted", this.checkEndOfTripCompletedStatus);
  }

  componentWillUnmount() {
    Events.off("EndOfTripCompleted", this.checkEndOfTripCompletedStatus);
  }

  getEndDateTimeError = (field, value) => {
    let errMsg = null;
    if (!value) {
      errMsg = "* Required";
    } else if (field === "endDate" && this.isArrivalDateAfterEndDate(value)) {
      errMsg = "End date should be greater than or equal to arrival date";
    } else if (field === "endTime" && this.isArrivalTimeAfterEndTime(value)) {
      errMsg = "End time should be greater than or equal to arrival time";
    }

    return errMsg;
  };

  getErrorInfo = () => {
    return {
      endDate: this.getEndDateTimeError("endDate", this.state.endDate),
      endTime: this.getEndDateTimeError("endTime", this.state.endTime),
    };
  };

  endTrip = () => {
    const errors = this.getErrorInfo();
    this.setState({
      isInvalidEndDate: false,
      isInvalidEndTime: false,
      errorInfo: errors,
    });

    const isEndDateTimeInValid = Object.values(errors).some((v) => v);

    if (isEndDateTimeInValid) {
      this.setState({
        formError: true,
      });
      return;
    }
    this.setState({
      isEndTripInProgress: true,
      formError: false,
    });
    const endDate = format(this.state.endDate, "yyyy-MM-dd");
    const endTime = formatTime({
      value: this.state.endTime,
    });
    const endDateTime = getTerminalDateWithOffset(
      `${endDate}T${endTime}:00.000Z`,
      this.props.userData.userProfile.terminal.offset
    );
    const requestData = {
      dispatchId: this.props.driverInfo.dispatchId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      trailerParkingInfo: [],
      arrivalOdometerReading: null,
      endTripDateTime: endDateTime,
    };

    postData("EndOfTrip", requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onEndOfTripFailed(response.status);
        }
      })
      .catch(() => {
        this.onEndOfTripFailed();
      });
  };

  checkEndOfTripCompletedStatus = (data) => {
    const { success } = data;
    if (success) {
      this.props.enqueueSnackbar(MESSAGES.END_TRIP.SUCCESS, {
        variant: "success",
      });
      this.setState({
        isEndTripInProgress: false,
      });
      this.props.onCancel();
    } else {
      this.onEndOfTripFailed();
    }
  };

  onEndOfTripFailed = (statusCode) => {
    this.setState({
      isEndTripInProgress: false,
    });
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(MESSAGES.END_TRIP.FAILURE, {
      variant: "error",
    });
  };

  handleOnEndDateTimeChange = (fieldName, value) => {
    if (value === this.state[fieldName]) {
      return;
    }
    const isFieldEndDate = fieldName === "endDate"; 
    const isValidValue = isFieldEndDate
      ? isValid(new Date(value))
      : isTimeValid(convertDateTimeToTimeString(value));
    if (!value || isValidValue) {
      const invalidFieldName = isFieldEndDate
        ? "isInvalidEndDate"
        : "isInvalidEndTime";
      this.setState(
        {
          [invalidFieldName]: false,
          [fieldName]: value,
        },
        () => this.updateEndDateTimeError(fieldName, value)
      );
    }
  };

  updateEndDateTimeError = (fieldName) => {
    this.setState((prevstate) => ({
      errorInfo: {
        endDate:
          fieldName === "endDate"
            ? this.getEndDateTimeError(fieldName, prevstate.endDate)
            : prevstate.errorInfo.endDate,
        endTime:
          fieldName === "endTime" || prevstate.endTime
            ? this.getEndDateTimeError("endTime", prevstate.endTime)
            : prevstate.errorInfo.endTime,
      },
    }));
  };

  handleEndTimeKeyDown = (e) => {
    if (this.state.endTime && e.keyCode !== BACKSPACE_KEYCODE) {
      return;
    }
    !this.state.isInvalidEndTime &&
      this.setState({
        isInvalidEndTime: true,
      });
  };

  handleEndDateKeyDown = (e) => {
     if (this.state.endDate && e.keyCode !== BACKSPACE_KEYCODE) {
       return;
     }
    !this.state.isInvalidEndDate &&
      this.setState({
        isInvalidEndDate: true,
      });
  };

  isArrivalTimeAfterEndTime = (date) => {
    const { arriveAtTerminalTime } = this.props.driverInfo;
    const { endDate } = this.state;

    if (endDate && this.isEndDateAfterArrivalDate(endDate)) {
      return false;
    }
    const endTime = formatTime({ value: date });
    const arrivalTime = formatArriveAtTerminalTime(arriveAtTerminalTime);

    return (
      new Date("1/1/1999 " + arrivalTime + ":00") >
      new Date("1/1/1999 " + endTime + ":00")
    );
  };

  isEndDateAfterArrivalDate = (date) => {
    const { arriveAtTerminalTime } = this.props.driverInfo;

    const endDate = new Date(format(date, "yyyy-MM-dd"));
    const arrivalDate = new Date(format(arriveAtTerminalTime, "yyyy-MM-dd"));
    return endDate > arrivalDate;
  };

  isArrivalDateAfterEndDate = (date) => {
    const { arriveAtTerminalTime } = this.props.driverInfo;

    const endDate = new Date(format(date, "yyyy-MM-dd"));
    const arrivalDate = new Date(format(arriveAtTerminalTime, "yyyy-MM-dd"));
    return arrivalDate > endDate;
  };

  onChangeEndDate = (val) => {
    if (isTimeValid(convertDateTimeToTimeString(val))) {
      val = val.split("T")[0];
    }
    this.handleOnEndDateTimeChange("endDate", val);
  };

  render() {
    const { classes } = this.props;
    const { driverNumber, driverName, arriveAtTerminalTime } =
      this.props.driverInfo;

    return (
      <Dialog
        open={true}
        aria-labelledby="EndTrip-title"
        classes={{ paper: classes.dialog }}
        maxWidth="sm"
      >
        <DialogTitle
          id="EndTrip-title"
          classes={{ root: classes.dialogTitlestyle }}
          disableTypography
        >
          <Grid container item lg={12} md={12} xs={12}>
            <Grid item md={11} xs={10}>
              <span className={classes.dialogTitle}>
                End Trip {driverName ? `for ${driverName} ${driverNumber}` : ""}
              </span>
            </Grid>
            <Grid item md={1} xs={2} className={classes.closeIcon}>
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={this.props.onCancel}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent classes={{ root: classes.dialogContent }}>
          <Grid container className={classes.datesContainer}>
            <Grid
              container
              item
              lg={12}
              md={12}
              xs={12}
              className={classes.datesInnerContainer}
            >
              <Grid item md={6} xs={6} className={classes.dateInfo}>
                <div className={classes.dateTimeTitle}>Arrival Date</div>
                <div className={classes.dateTimeValue}>
                  {format(
                    arriveAtTerminalTime,
                    appConstants.DATETYPES.MONTHDATEYEAR.format
                  )}
                </div>
              </Grid>
              <Grid item md={6} xs={6} className={classes.dateInfo}>
                <div className={classes.dateTimeTitle}>End Date</div>
                <div className={classes.dateTimeEditor}>
                  <StyledDateTimeEditor
                    dateType={appConstants.DATETYPES.MONTHDATEYEAR}
                    value={formatMonthDateYear({ value: this.state.endDate })}
                    onChange={this.onChangeEndDate}
                    onKeyDown={this.handleEndDateKeyDown}
                    shouldDisableDate={this.isArrivalDateAfterEndDate}
                  />
                </div>
              </Grid>
              {!this.state.isInvalidEndDate && this.state.errorInfo.endDate && (
                <span className={classes.errorMsgs}>
                  {this.state.errorInfo.endDate}
                </span>
              )}
            </Grid>
            <Grid
              container
              item
              lg={12}
              md={12}
              xs={12}
              className={classes.datesInnerContainer}
            >
              <Grid item md={6} xs={6} className={classes.dateInfo}>
                <div className={classes.dateTimeTitle}>Arrival Time</div>
                <div className={classes.dateTimeValue}>
                  {formatArriveAtTerminalTime(arriveAtTerminalTime)}
                </div>
              </Grid>
              <Grid item md={6} xs={6} className={classes.dateInfo}>
                <div className={classes.dateTimeTitle}>End Time</div>
                <div className={classes.dateTimeEditor}>
                  <StyledDateTimeEditor
                    dateType={appConstants.DATETYPES.TIME}
                    value={convertDateTimeToTimeString(this.state.endTime)}
                    onChange={(val) =>
                      this.handleOnEndDateTimeChange("endTime", val)
                    }
                    onKeyDown={this.handleEndTimeKeyDown}
                  />
                </div>
              </Grid>
              {!this.state.isInvalidEndTime && this.state.errorInfo.endTime && (
                <span className={classes.errorMsgs}>
                  {this.state.errorInfo.endTime}
                </span>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogAction }}>
          <Grid container spacing={24}>
            <Grid item xs={4}></Grid>
            <Grid item xs={8} classes={{ item: classes.actionButton }}>
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                className={classes.button}
                onClick={this.props.onCancel}
                disabled={this.state.isEndTripInProgress}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                size="small"
                disableRipple
                className={classes.confirmButton}
                onClick={this.endTrip}
                disabled={this.state.isEndTripInProgress}
                classes={{ disabled: classes.disabledConfirmButton }}
              >
                {this.state.isEndTripInProgress ? (
                  <CircularProgress
                    size={16}
                    classes={{ root: classes.circularProgress }}
                  />
                ) : (
                  "Confirm"
                )}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}
export default compose(
  withSnackbar,
  withStyles(styles)
)(EndTripConfirmation);
